import React, { Component } from 'react';
import HomeCarousel from '../components/HomeCarousel';

import {Container, Row, Col } from 'react-bootstrap';

import { connect } from 'react-redux'

import '../stylesheets/Home.css';

import Loading from '../components/Loading'

class Home extends Component {
  // Initialize the state
  constructor(props){
    super(props);
    this.state = {
      countries: undefined,
      mobile: undefined
    }

    this.getCountries = this.getCountries.bind(this);
  }

  componentDidMount() {

    // Fetch all countries
    this.getCountries()
  }

  getCountries() {
    fetch('/api/getCountries', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then(response => response.json())
    .then(data => {
      this.setState({countries: data.countries})
    })
  }

  countryClicked = (item) => {
    let url = "/country/" + item.country;
    this.props.history.push(url);
  }

  render() {
    // let height = (window.innerWidth <= 760) ? 150 : 200;

    console.log(this.props.Auth);

    const CountriesGrid = () => (
      <Container>
        <Row>
          {
          this.state.countries.map(item => (
            <Col key={item.country} xs={6} md={4}>
              <div onClick={()=> this.countryClicked(item)} className="gridImageContainer">
                <img className="country-img img-fluid w-100" id="gridImage" src={item.img} alt={item.country} style={{objectPosition: 'center', objectFit: 'cover'}}/>
                <h2 id="h2Country">{item.country}</h2>
              </div>
            </Col>
          ))
          }
        </Row>
      </Container>
    )


    return (
      <div className="App">
        <div style={{height: 400}}>
          <HomeCarousel />
        </div>

        <h3 id="h2Home">SELECT A COUNTRY TO BOOK YOUR RENTAL BIKE</h3>
        {
          this.state.countries ? <CountriesGrid/> : <Loading />
        }
      </div>
    );
  }
}

// const styles = {
//   root: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     justifyContent: 'space-around',
//     overflow: 'hidden',
//   },
//   gridList: {
//     width: (window.innerWidth <= 760) ? window.innerWidth-20 : 800
//     // height: 450,
//   },
// }

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth
  }
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    // height: 450,
  },
});

export default  connect(mapStateToProps)(Home);